import * as React from "react";
export class StakeValue extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-my-pulse-bets__stake-value" },
            React.createElement("span", null, this.props.stakeValue)));
    }
}
//# sourceMappingURL=StakeValue.js.map